(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookies-popup"]) return;
  try {
    
  jQuery(function() {
	initCookiesPopup();
  });

  function initCookiesPopup() {
	var popup = jQuery('#cookies_popup');
	var openedClass = 'opened';
	var bodyOpenedClass = 'cookies-popup-opened';
	var closeBtn = popup.find('.close');
	var body = jQuery('body');

	closeBtn.on('click', function(e) {
		e.preventDefault();

        setCookie('cookies_popup_disabled', '1');
		hidePopup();
	});

	if (getCookie('cookies_popup_disabled') !== '1') {
      setTimeout(function() {
		if (popup.length) {
            showPopup();
		}
      }, popup.data('delay'));
	}

	function showPopup() {
		popup.addClass(openedClass);
		body.addClass(bodyOpenedClass);
    }

	function hidePopup() {
		popup.removeClass(openedClass);
		body.removeClass(bodyOpenedClass);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  jQuery(function() {
	initNewsletterPopup();
  });

  function initNewsletterPopup() {
	var popup = jQuery('#newsletter_popup');
	var openedClass = 'opened';
	var bodyOpenedClass = 'newsletter-popup-opened';
	var control = jQuery('#newsletter-popup_control');
	var closeBtn = popup.find('.close');
	var body = jQuery('body');

	closeBtn.on('click', function(e) {
		e.preventDefault();

    if (jQuery(this).hasClass('newsletter-popup__close')) {
      setCookie('newsletter_popup_disabled', '1');
    }
		hidePopup();
	});

	if (getCookie('newsletter_popup_disabled') !== '1') {
      setTimeout(function() {
		if (popup.length) {
            showPopup();
            controlCookie();

            jQuery(document).on('click',function (e) {
                if(popup.hasClass(openedClass)) {
                    if (!jQuery(e.target).closest(popup).length) {
                        hidePopup();
                    }
                }
            });
		}
      }, popup.data('delay'));
	}

	function showPopup() {
		popup.addClass(openedClass);
		body.addClass(bodyOpenedClass);
    }

	function hidePopup() {
		popup.removeClass(openedClass);
		body.removeClass(bodyOpenedClass);

        if (popup.find('.newsletter-popup__thankyou-message').length) {
            setCookie('newsletter_popup_disabled', '1');
        }
    }

    function controlCookie() {
		control.on('submit.CookiesControl', function() {
			if (jQuery(this).is(':checked')) {
				setCookie('newsletter_popup_disabled', '1');
			} else {
				deleteCookie('newsletter_popup_disabled');
			}
		});
    }
  }

  } catch(e) { console.error(e); }
})();
})();
